//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import LineChart from './charts/LineChart';
import EmptyContent from '@nextcloud/vue/dist/Components/EmptyContent';
import moment from 'moment';
export default {
  name: 'Chart',
  components: {
    LineChart: LineChart,
    EmptyContent: EmptyContent
  },
  props: {
    chartType: {
      type: String,
      default: 'line' // only line charts for now!

    },
    data: {
      type: Array,
      default: null
    },
    definition: {
      type: Array,
      default: null
    },
    options: {
      type: Object,
      default: null
    },
    rangeDefinition: {
      type: String,
      default: 'month'
    },
    chartStyle: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      range: this.rangeDefinition
    };
  },
  computed: {
    getOptions: function getOptions() {
      var _this = this;

      if (!this.options) {
        return [];
      }

      var AllYAxes = this.options.scales.yAxes.slice(); // eslint-disable-next-line vue/no-side-effects-in-computed-properties

      this.options.scales.yAxes = [];
      var axesIds = {};
      this.getChartData.datasets.forEach(function (item) {
        if ('yAxisID' in item) {
          axesIds[item.yAxisID] = true;
        }
      }); // console.debug('axesIds', axesIds)

      AllYAxes.forEach(function (axes, i) {
        if (axes.id in axesIds && axesIds[axes.id]) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          _this.options.scales.yAxes.push(AllYAxes[i]);
        }
      });
      return this.options;
    },
    getChartData: function getChartData() {
      var _this2 = this;

      if (!this.definition || !this.data) {
        return [];
      }

      var data = {};
      this.data.forEach(function (d) {
        _this2.definition.forEach(function (def) {
          if (!data[def.columnId]) {
            data[def.columnId] = [];
          }

          if (def.valueId !== 'calculate' && d[def.timeId] && !Number.isNaN(d[def.valueId]) && _this2.isInTimeRange(d[def.timeId]) && def.show) {
            data[def.columnId].push({
              t: moment(d[def.timeId]),
              y: def.getValueY(d[def.valueId])
            });
          } else if (def.valueId === 'calculate' && d[def.timeId] && _this2.isInTimeRange(d[def.timeId]) && def.show) {
            data[def.columnId].push({
              t: moment(d[def.timeId]),
              y: def.getValueY(d)
            });
          } else if (def.valueId === 'static' && d[def.timeId] && _this2.isInTimeRange(d[def.timeId]) && def.show) {
            data[def.columnId].push({
              t: moment(d[def.timeId]),
              y: def.getValueY
            });
          }
        });
      }); // console.debug('data in get datasets for chartData', data)

      var result = {
        datasets: []
      };
      this.definition.forEach(function (set) {
        var push = {
          label: set.title,
          data: data[set.columnId]
        };

        if ('backgroundColor' in set) {
          push.backgroundColor = set.backgroundColor;
        }

        if ('borderColor' in set) {
          push.borderColor = set.borderColor;
        }

        if ('borderDash' in set) {
          push.borderDash = set.borderDash;
        }

        if ('borderWidth' in set) {
          push.borderWidth = set.borderWidth;
        }

        if ('fill' in set) {
          push.fill = set.fill;
        }

        if ('type' in set) {
          push.type = set.type;
        }

        if ('axesId' in set) {
          push.yAxisID = set.axesId;
        }

        if (set.show) {
          result.datasets.push(push);
        }
      }); // console.debug('chartData', result)

      return result;
    },
    isDetailRange: function isDetailRange() {
      return !(this.rangeDefinition === 'week' || this.rangeDefinition === 'month' || this.rangeDefinition === 'year');
    },
    rangeDays: function rangeDays() {
      if (this.range === 'week') {
        return 7;
      } else if (this.range === 'month') {
        return 31;
      } else if (this.range === 'year') {
        return 365;
      } else {
        return -1;
      }
    },
    rangeHours: function rangeHours() {
      if (this.range === '1hour') {
        return 1;
      } else if (this.range === '4hours') {
        return 4;
      } else if (this.range === '12hours') {
        return 12;
      } else if (this.range === '24hours') {
        return 24;
      } else if (this.range === '48hours') {
        return 48;
      } else {
        return -1;
      }
    }
  },
  methods: {
    isInTimeRange: function isInTimeRange(date) {
      if (this.rangeDays !== -1 && !this.isDetailRange) {
        return Math.abs(moment(date).diff(moment(), 'days')) <= this.rangeDays;
      } else if (this.rangeHours !== -1 && this.isDetailRange) {
        return Math.abs(moment(date).diff(moment(), 'hours')) <= this.rangeHours;
      } else {
        return true;
      }
    }
  }
};